var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var LinkSvg = /* @__PURE__ */ __name(function LinkSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M22.382 16.618l-1.844-1.24 4.351-6.489c0.172-0.403 0.272-0.872 0.272-1.364 0-1.964-1.592-3.556-3.556-3.556-0.972 0-1.853 0.39-2.495 1.022l0-0-4.742 7.009-1.844-1.24 4.876-7.204c1.058-1.138 2.564-1.848 4.235-1.848 3.191 0 5.778 2.587 5.778 5.778 0 0.887-0.2 1.727-0.557 2.478l0.015-0.035-0.080 0.138z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M10.32 30.222c-3.182-0.012-5.757-2.594-5.757-5.778 0-0.906 0.209-1.764 0.581-2.528l-0.015 0.034 0.080-0.138 4.409-6.551 1.844 1.24-4.351 6.484c-0.174 0.405-0.275 0.876-0.275 1.371 0 1.964 1.592 3.556 3.556 3.556 0.973 0 1.856-0.391 2.498-1.025l-0 0 4.742-7.031 1.844 1.24-4.889 7.222c-1.057 1.166-2.576 1.897-4.266 1.902h-0.001z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12.322 19.631l6.611-9.828 1.844 1.24-6.611 9.828-1.844-1.24z"
  }));
}, "LinkSvg");
var LinkIcon = /* @__PURE__ */ __name(function LinkIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: LinkSvg
  }, props));
}, "LinkIcon");
export {
  LinkIcon
};
